import React, { useState } from 'react';
import ReactLoading from 'react-loading';
import LocalizedMessage from 'react-l10n';
import ReactTableWrapper from '../../ReactTableWrapper';
import Field from '../../fields/Field';
// Import other dependencies as needed

function AccountAddressList(props) {
    const {
        isLoading,
        list,
        onRemoveClick,
        onMakeDefaultClick,
        onEditClick,
    } = props;
    const [
        showRemoveConfirmationModal,
        setShowRemoveConfirmationModal,
    ] = useState({});
    const [isDeleting, setIsDeleting] = useState({});
    const [isDefaulting, setIsDefaulting] = useState({});
    const [searchKeyword, setSearchKeyword] = useState('');
    const [itemsToShow, setItemsToShow] = useState(10); // State to manage the number of items to show

    // Handler for the Load More button
    const handleLoadMore = () => {
        setItemsToShow(itemsToShow + 5); // Increase the number of items to show by 5
    };
    const handleLoadLess = () => {
        setItemsToShow(10); // Increase the number of items to show by 5
    };
    // Filter function with slice to manage displayed items
    const filterList = () => {
        return (!searchKeyword
            ? list
            : list.filter((item) =>
                  item.BusinessName?.toLowerCase().includes(
                      searchKeyword.toLowerCase()
                  )
              )
        ).slice(0, itemsToShow); // Slice the list based on itemsToShow
    };

    let defaultRefs = {};

    /**
     * Toggle isDefaulting value
     *
     * @param key
     * @param value
     */
    const toggleIsDefaulting = (key, value) => {
        setIsDefaulting((prevState) => {
            return {
                ...prevState,
                [key]: value,
            };
        });
    };

    /**
     * Toggle isDeleting value
     *
     * @param key
     * @param value
     */
    const toggleIsDeleting = (key, value) => {
        setIsDeleting((prevState) => {
            return {
                ...prevState,
                [key]: value,
            };
        });
    };

    /**
     * Handler when user confirms removing a row
     *
     * @param row
     */
    const onConfirmRemoveRow = (row) => {
        const identifier = row.original.ID;

        toggleShowRemoveConfirmationModal(row, false);
        toggleIsDeleting(identifier, true);

        onRemoveClick(identifier, {
            always: () => {
                toggleIsDeleting(identifier, false);
            },
        });
    };

    /**
     * Handler when user clicks make default button
     *
     * @param row
     */
    const handleMakeDefault = (row) => {
        const identifier = row.original.ID;

        // lose focus
        defaultRefs[identifier].blur();

        toggleIsDefaulting(identifier, true);
        onMakeDefaultClick(identifier, {
            always: () => {
                toggleIsDefaulting(identifier, false);
            },
        });
    };

    /**
     * Toggle the show remove confirmation modal
     *
     * @param row
     * @param value
     */
    const toggleShowRemoveConfirmationModal = (row, value) => {
        const { viewIndex } = row;

        setShowRemoveConfirmationModal({
            ...showRemoveConfirmationModal,
            [viewIndex]: value,
        });
    };

    /**
     * Check if we are showing remove confirmation on this row
     *
     * @param row
     * @returns {boolean}
     */
    const getRemoveConfirmation = (row) => {
        const { viewIndex } = row;

        return typeof showRemoveConfirmationModal[viewIndex] != 'undefined'
            ? showRemoveConfirmationModal[viewIndex]
            : false;
    };

    /**
     * Get the React Table props
     *
     * @returns {{list: {columns: *[], showPagination: boolean}}}
     */
    const getTableProps = () => {
        // const lessThanMD = wWidth < breakpoints.md;
        const tableProps = {
            list: {
                columns: [
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'BUSINESS_NAME'}
                                        />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'dt-delivery-address__nickname',
                        className: 'dt-delivery-address__nickname',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'BusinessName',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'PHONE'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'dt-delivery-address__nickname',
                        className: 'dt-delivery-address__nickname',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'Phone',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage id={'ADDRESS'} />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__info'>
                                        {row.value}
                                    </span>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'dt-delivery-address__address',
                        className: 'dt-delivery-address__address',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'FullAddress',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'CURRENT_DELIVERY'}
                                        />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            return (
                                <React.Fragment>
                                    {row.value == 1 && (
                                        <button
                                            type='button'
                                            className='button-set-default button-set-default--active'
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <span className='icon icon-check-thick' />
                                        </button>
                                    )}
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'react-table__make-default-col',
                        className: 'react-table__make-default-col',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'IsDelivery',
                    },
                    {
                        Header: () => {
                            return (
                                <React.Fragment>
                                    <span className='react-table__heading'>
                                        <LocalizedMessage
                                            id={'CURRENT_BILLING'}
                                        />
                                    </span>
                                </React.Fragment>
                            );
                        },
                        Cell: (row) => {
                            const identifier = row.original.ID;
                            const isColumnLoading =
                                typeof isDefaulting[identifier] != 'undefined'
                                    ? isDefaulting[identifier]
                                    : false;
                            const hasOtherAction =
                                typeof isDeleting[identifier] != 'undefined'
                                    ? isDeleting[identifier]
                                    : false;

                            if (hasOtherAction) {
                                return '';
                            }

                            return (
                                <React.Fragment>
                                    {isColumnLoading ? (
                                        <ReactLoading
                                            type='spin'
                                            color='black'
                                            height={20}
                                            width={20}
                                        />
                                    ) : (
                                        <React.Fragment>
                                            {row.value == 1 ? (
                                                <button
                                                    ref={(r) => {
                                                        defaultRefs[
                                                            identifier
                                                        ] = r;
                                                    }}
                                                    type='button'
                                                    className='button-set-default button-set-default--active'
                                                    onClick={(e) =>
                                                        e.preventDefault()
                                                    }
                                                >
                                                    <span className='icon icon-check-thick' />
                                                </button>
                                            ) : (
                                                <button
                                                    ref={(r) => {
                                                        defaultRefs[
                                                            identifier
                                                        ] = r;
                                                    }}
                                                    type='button'
                                                    className='button-set-default'
                                                    onClick={(e) =>
                                                        handleMakeDefault(row)
                                                    }
                                                >
                                                    <span className='icon icon-check-thick' />
                                                </button>
                                            )}
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'react-table__make-default-col',
                        className: 'react-table__make-default-col',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'IsBilling',
                    },
                    {
                        Cell: (row) => {
                            const identifier = row.original.ID;
                            const isColumnLoading = false;

                            return (
                                <React.Fragment>
                                    {isColumnLoading ? (
                                        <ReactLoading
                                            type='spin'
                                            color='black'
                                            height={20}
                                            width={20}
                                        />
                                    ) : (
                                        <a
                                            className='button button--thin button--small button--light-grey'
                                            onClick={(e) => onEditClick(row)}
                                        >
                                            <LocalizedMessage id={'EDIT'} />
                                        </a>
                                    )}
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'react-table__edit-col hidden-xs',
                        className: 'react-table__edit-col hidden-xs',
                        minWidth: undefined,
                        sortable: false,
                    },
                    {
                        Cell: (row) => {
                            const identifier = row.original.ID;
                            const isColumnLoading =
                                typeof (isDeleting != 'undefined') &&
                                typeof isDeleting[identifier] != 'undefined'
                                    ? isDeleting[identifier]
                                    : false;

                            if (!row.original.CanDelete) {
                                return '';
                            }

                            return (
                                <React.Fragment>
                                    {isColumnLoading ? (
                                        <ReactLoading
                                            type='spin'
                                            color='black'
                                            height={20}
                                            width={20}
                                        />
                                    ) : (
                                        <button
                                            type='button'
                                            className='button-link-plain button-link-plain--light-grey button-link-plain--small'
                                            onClick={(e) =>
                                                toggleShowRemoveConfirmationModal(
                                                    row,
                                                    true
                                                )
                                            }
                                        >
                                            <span className='icon icon-bin-thick' />
                                        </button>
                                    )}
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'react-table__remove-col hidden-xs',
                        className: 'react-table__remove-col hidden-xs',
                        minWidth: undefined,
                        sortable: false,
                        accessor: 'IsDelete',
                    },
                    {
                        expander: true,
                        Expander: ({ isExpanded, ...rest }) => {
                            return (
                                <React.Fragment>
                                    <button
                                        type='button'
                                        className='react-table__extra-data-toggle'
                                    >
                                        <span className='icon icon-chevron-thick' />
                                    </button>
                                </React.Fragment>
                            );
                        },
                        headerClassName: 'hidden',
                        className: 'hidden',
                        width: 45,
                        sortable: false,
                        accessor: 'ID',
                    },
                ],
                showPagination: false,
            },
        };

        return tableProps;
    };

    return (
        <div>
            <Field
                label={'Search address by business name'}
                animatedLabel={'Search address by business name'}
                value={searchKeyword}
                onChange={(e) => setSearchKeyword(e.target.value)}
            />
            
            <ReactTableWrapper
                loading={isLoading}
                data={filterList()}
                reactTable={getTableProps()} // Make sure you define this function to set up your table columns
                hasRemoveConfirmation={true}
                toggleRemoveConfirmation={toggleShowRemoveConfirmationModal}
                getRemoveConfirmation={getRemoveConfirmation}
                onRemoveRow={onConfirmRemoveRow}
                perPage={list.length}
            />
            {itemsToShow < list.length && list.length != 0 && ( // Show the Load More button if there are more items to show
                <button
                    className='button button-filter button--grey-border'
                    onClick={handleLoadMore}
                    style={{ marginTop: '20px' }}
                >
                    Load More 
                </button>
            )}
            {itemsToShow >= list.length && list.length > 5 && ( // Show the Load More button if there are more items to show
                <button
                    className='button button-filter button--grey-border'
                    onClick={handleLoadLess}
                    style={{ marginTop: '20px' }}
                >
                    Load Less
                </button>
            )}
        </div>
    );
}

export default AccountAddressList;

